import React from 'react';
import { FileTextIcon, CheckCircleIcon, AlertTriangleIcon, XCircleIcon, CopyIcon, AlertOctagonIcon } from 'lucide-react';
interface SummaryCardsProps {
  totalRows: number;
  validRows: number;
  matchedCount: number;
  missingCount: number;
  duplicateCount: number;
  validationErrorCount: number;
}
interface MetricCardProps {
  label: string;
  value: number;
  icon: React.ReactNode;
  colorClass: string;
  bgClass: string;
}
function MetricCard({
  label,
  value,
  icon,
  colorClass,
  bgClass
}: MetricCardProps) {
  return <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-5 flex items-start gap-4" data-id="element-115">
      <div className={`flex-shrink-0 w-11 h-11 rounded-lg flex items-center justify-center ${bgClass}`} data-id="element-116">
        {icon}
      </div>
      <div data-id="element-117">
        <p className="text-sm text-gray-500 font-medium" data-id="element-118">{label}</p>
        <p className={`text-3xl font-semibold mt-0.5 ${colorClass}`} data-id="element-119">
          {value.toLocaleString()}
        </p>
      </div>
    </div>;
}
export function SummaryCards({
  totalRows,
  validRows,
  matchedCount,
  missingCount,
  duplicateCount,
  validationErrorCount
}: SummaryCardsProps) {
  return <section aria-label="Processing summary" data-id="element-120">
      <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-121">
        Processing Summary
      </h3>
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-122">
        <MetricCard label="Total Rows" value={totalRows} icon={<FileTextIcon className="w-5 h-5 text-blue-600" aria-hidden="true" data-id="element-124" />} colorClass="text-gray-900" bgClass="bg-blue-50" data-id="element-123" />
        <MetricCard label="Valid Rows" value={validRows} icon={<CheckCircleIcon className="w-5 h-5 text-blue-600" aria-hidden="true" data-id="element-126" />} colorClass="text-gray-900" bgClass="bg-blue-50" data-id="element-125" />
        <MetricCard label="Matched" value={matchedCount} icon={<CheckCircleIcon className="w-5 h-5 text-green-600" aria-hidden="true" data-id="element-128" />} colorClass="text-green-700" bgClass="bg-green-50" data-id="element-127" />
        <MetricCard label="Missing" value={missingCount} icon={<AlertTriangleIcon className="w-5 h-5 text-red-600" aria-hidden="true" data-id="element-130" />} colorClass="text-red-700" bgClass="bg-red-50" data-id="element-129" />
        <MetricCard label="Duplicates" value={duplicateCount} icon={<CopyIcon className="w-5 h-5 text-amber-600" aria-hidden="true" data-id="element-132" />} colorClass="text-amber-700" bgClass="bg-amber-50" data-id="element-131" />
        <MetricCard label="Validation Errors" value={validationErrorCount} icon={<AlertOctagonIcon className="w-5 h-5 text-red-500" aria-hidden="true" data-id="element-134" />} colorClass="text-red-600" bgClass="bg-red-50" data-id="element-133" />
      </div>
    </section>;
}